import { useState, useEffect, useCallback } from "react";
import { processosService } from "../api/processosService";
import { ordenarProcessosPorPrioridade } from "../utils/prioridadesProcessos";

const useProcessos = (autoLoad = true, usuarios = []) => {
  const [processos, setProcessos] = useState([]);
  const [busca, setBusca] = useState("");
  const [paginaAtual, setPaginaAtual] = useState(1);
  const processosPorPagina = 10;

  const carregarProcessos = useCallback(async () => {
    try {
      const data = await processosService.listar();
      setProcessos(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error("Erro ao carregar processos:", error);
    }
  }, []);

  const buscarPorCliente = useCallback(async (clienteId) => {
    try {
      if (!clienteId) {
        setProcessos([]);
        return;
      }
      const data = await processosService.listar(clienteId);
      setProcessos(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error("Erro ao buscar processos por cliente:", error);
    }
  }, []);

  useEffect(() => {
    if (autoLoad) {
      carregarProcessos();
    }
  }, [autoLoad, carregarProcessos]);

  const cadastrarProcesso = async (novoProcesso) => {
    const processo = await processosService.criar(novoProcesso);
    await carregarProcessos();
    return processo;
  };

  const deletarProcesso = async (id) => {
    const confirmar = window.confirm("Deseja realmente excluir o processo?");
    if (!confirmar) return;
    await processosService.excluir(id);
    await carregarProcessos();
  };

  const editarProcesso = async (id, alteracoes) => {
    await processosService.atualizar(id, alteracoes);
    await carregarProcessos();
  };

  // Filtragem de processos (incluindo número, autor, área, notificação e advogado)
  const processosFiltrados = processos.filter((p) => {
    const termo = busca.toLowerCase();

    const nomeNotificacao =
      (typeof p.nomeNotificacao === "string" ? p.nomeNotificacao : p.nomeNotificacao?.texto) ||
      p.ultimaMovimentacao?.tipoEspecializado ||
      "";

    const advogadoObj = usuarios.find(
      (u) => (u._id || u.id)?.toString() === p.advogadoId?.toString()
    );
    const nomeAdvogado = advogadoObj?.nome || "";

    return (
      (p.numeroProcesso || "").toLowerCase().includes(termo) ||
      (p.autor || "").toLowerCase().includes(termo) ||
      (p.areaDireito || "").toLowerCase().includes(termo) ||
      nomeNotificacao.toLowerCase().includes(termo) ||
      nomeAdvogado.toLowerCase().includes(termo)
    );
  });

  const processosOrdenados = ordenarProcessosPorPrioridade(processosFiltrados);

  const indiceFinal = paginaAtual * processosPorPagina;
  const indiceInicial = indiceFinal - processosPorPagina;

  const processosPagina = processosOrdenados.slice(indiceInicial, indiceFinal);
  const totalPaginas = Math.ceil(processosOrdenados.length / processosPorPagina);

  return {
    processos,
    busca,
    setBusca,
    paginaAtual,
    setPaginaAtual,
    processosPagina,
    totalPaginas,
    cadastrarProcesso,
    deletarProcesso,
    editarProcesso,
    buscarPorCliente
  };
};

export default useProcessos;